import { PowerOff } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router";
import { Button } from "@altek/ui/components/ui/Button";
import { useScreenTitle } from "@/app/layouts/document-title";

/**
 * «BU EKRAN BU KURULUMDA KAPALI» — 1 Kasım 2026 (kullanıcı kararı: teklif, sipariş, döviz kuru ve karekod
 * bu kurulumda kalksın; kod ve veri kalsın).
 *
 * YALNIZ İZNİ OLANA. `NotFoundScreen` bir ekranın VAR olduğunu söylememek için iki kapıda aynı cümleyi
 * kuruyor ve o kural duruyor: izni olmayan kişi kapalı modülün adresinde yine «Sayfa bulunamadı» görüyor.
 * Bu ekranı yalnız anahtarı TUTAN kişi görüyor — ekranı zaten tanıyor, dün kullanıyordu; ona «bulunamadı»
 * demek onu bir hata bildirmeye gönderirdi. Geri açmak tek ayar: Sistem › Modüller.
 *
 * Görünüş `NotFoundScreen` ile aynı (simge, `<h1>`, `42ch` açıklama, iki eylem).
 */
export function ModuleOffScreen() {
  useScreenTitle("Bu kurulumda kapalı");
  const navigate = useNavigate();
  /** React Router ilk girişe `"default"` anahtarını veriyor: geri gidilecek bir sayfa yok. */
  const canGoBack = useLocation().key !== "default";

  return (
    <div className="grid min-h-[60vh] place-items-center p-6">
      <div className="flex flex-col items-center gap-3 px-6 py-14 text-center">
        <PowerOff size={28} strokeWidth={1.6} className="text-fg-subtle" aria-hidden="true" />
        <h1 className="text-md font-semibold text-fg">Bu ekran bu kurulumda kapalı</h1>
        <p className="max-w-[42ch] text-sm text-fg-muted">
          Bağlı olduğu modül bu kurulumda kapatıldı; kayıtları silinmedi. Yeniden açmak için sistem
          yöneticiniz Sistem › Modüller'den modülü açabilir.
        </p>
        <div className="mt-1 flex flex-wrap justify-center gap-2">
          {canGoBack ? (
            <Button variant="secondary" className="max-md:h-11" onClick={() => void navigate(-1)}>
              Geri dön
            </Button>
          ) : null}
          <Button asChild variant="secondary" className="max-md:h-11">
            <Link to="/">Başlangıca dön</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
